import DealerProfilePanel from "./dealerProfilePanel.container";

export default DealerProfilePanel;